import React, { useEffect, useCallback, useState, useRef } from "react";
import classNames from "classnames/bind";
import s from "./MainLayout.module.scss";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import MenuIcon from "@material-ui/icons/Menu";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import {
  CssBaseline,
  Tooltip,
  Menu,
  MenuItem,
  Typography,
  Drawer,
} from "@material-ui/core";
import domtoimage from "dom-to-image";
import * as jsPDF from "jspdf";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";
import SnackBar from "../common/SnackBar/SnackBar";
import { hexToRgbA } from "../common/utils";
import {
  getLayoutDetail,
  setDefaultState,
  updateAdditionalSections,
  setImportedDataFromFile,
} from "./action";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import BackDropLoader from "../common/BackDropLoader/BackDropLoader";
import SimplePopover from "../common/PopOver/PopOver";
import AboutMeEdit from "../AboutMe/AboutMeEdit";
import WorkExEdit from "../CustomExpansionPanel/WorkExEdit";
import SkillsEdit from "../Demo/SkillsEdit";
import ProjectEdit from "../ProjectEdit/ProjectEdit";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import {
  SWITCH_TO_DESKTOP,
  DOWNLOAD_SUCCESSFULL,
  SECTION,
  LOCAL_STORAGE,
  MENU_ITEMS,
  DOWNLOAD_TYPES,
} from "../../constants/constants";
import { isMobile, saveResumeToFile } from "../common/utils";
import EducationEdit from "../Education/EducationEdit";
import { GA_REACT } from "../common/GA-React";
import DefaultTemplate from "../templates/defaultTemplate/defaultTemplate";
import ChooseTemplate from "../ChooseTemplate/ChooseTemplate";
import SidePanelTemplate from "../templates/sidePanelTemplate/sidePanelTemplate";
import SimpleTemplate from "../templates/simpleTemplate/simpleTemplate";
import CheckBoxGroup from "../common/CheckBoxGroup/CheckBoxGroup";
import firebase from "../../firebase/firebase";
import ExploreFeatures from "../ExploreFeatures/ExploreFeatures";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import SideDetailsTemplate from "../templates/sideDetailsTemplate/sideDetailsTemplate";
import ModernTemplate from "../templates/modernTemplate/modernTemplate";
import DesignTemplate from "../templates/designTemplate/designTemplate";

const MainLayout = (props) => {
  const memoizedLayoutDetail = useCallback(props.getLayoutDetail);
  useEffect(() => {
    memoizedLayoutDetail();
    const savedResponse = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE.SAVED_DATA_KEY)
    );
    savedResponse &&
      setSnackBarData({
        open: true,
        message: SECTION.LAST_SAVED_DATA,
      });
    setTimeout(() => {
      setSnackBarData({
        open: true,
        message: SECTION.SWITCH_TO_MODE("Create your Own Resume"),
      });
    }, 20000);
  }, [memoizedLayoutDetail]);
  const [snackBarData, setSnackBarData] = React.useState({
    open: false,
    message: SWITCH_TO_DESKTOP(),
  });
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);

  const handleSnackBarClose = () =>
    setSnackBarData({
      ...snackBarData,
      open: false,
    });

  const handleAfterResumeDownload = (type) => {
    if (isMobile()) {
      setTimeout(() => {
        setSnackBarData({
          ...snackBarData,
          open: true,
          message: SWITCH_TO_DESKTOP("have Proper Resume Format"),
        });
      }, 10000);
      props.useGA &&
        firebase.firestore().collection("resumes").add({
          initialData: props.initialData,
          additionalSections: props.additionalSections,
          viewType: props.viewType,
          templateSelected: props.templateSelected,
          themeType: props.themeType,
          isDesktop: false,
          type,
        });
      props.useGA &&
        GA_REACT.createEvent(GA_REACT.ACTION.MOBILE.DOWNLOAD_RESUME, {
          label: JSON.stringify(props.initialData),
        });
      return;
    }
    props.useGA &&
      console.log({
        initialData: props.initialData,
        additionalSections: props.additionalSections,
        viewType: props.viewType,
        templateSelected: props.templateSelected,
        themeType: props.themeType,
        isDesktop: true,
        type,
      });
    props.useGA &&
      firebase.firestore().collection("resumes").add({
        initialData: props.initialData,
        additionalSections: props.additionalSections,
        viewType: props.viewType,
        templateSelected: props.templateSelected,
        themeType: props.themeType,
        isDesktop: true,
        type,
      });
    props.useGA &&
      GA_REACT.createEvent(GA_REACT.ACTION.DESKTOP.DOWNLOAD_RESUME, {
        label: JSON.stringify(props.initialData),
      });
  };

  const downloadResume = (type = DOWNLOAD_TYPES.PDF) => {
    setIsLoading(true);
    if (type === DOWNLOAD_TYPES.FILE) {
      saveResumeToFile(
        JSON.parse(localStorage.getItem(LOCAL_STORAGE.SAVED_DATA_KEY))
      )();
      setSnackBarData({
        ...snackBarData,
        open: true,
        message: DOWNLOAD_SUCCESSFULL,
      });
      setIsLoading(false);
      handleAfterResumeDownload(type);
      return;
    }

    const rootNode = document.querySelector("#root-container");
    const HTML_Width = rootNode.getBoundingClientRect().width;
    const HTML_Height = rootNode.getBoundingClientRect().height;
    const top_left_margin = 15;
    const PDF_Width = HTML_Width + top_left_margin * 2;
    const PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
    const canvas_image_width = HTML_Width;
    const canvas_image_height = HTML_Height;
    const totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    // const prevBgColor = rootNode.style.backgroundColor;
    // rootNode.style.backgroundColor =
    // props.themeType === "light" ? "rgba(255,255,255,1)" : "rgba(66,66,66,1)";
    domtoimage.toPng(rootNode, { quality: 0.95 }).then(function (dataUrl) {
      // rootNode.style.backgroundColor = prevBgColor;
      if (type === DOWNLOAD_TYPES.JPEG) {
        const link = document.createElement("a");
        link.download = `${SECTION.RESUME_NAME}.jpeg`;
        link.href = dataUrl;
        link.click();
        setSnackBarData({
          ...snackBarData,
          open: true,
          message: DOWNLOAD_SUCCESSFULL,
        });
        setIsLoading(false);
        handleAfterResumeDownload(type);
        return;
      }

      const imgData = dataUrl;
      const pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
      pdf.addImage(
        imgData,
        "JPG",
        top_left_margin,
        top_left_margin,
        canvas_image_width,
        canvas_image_height
      );

      for (let i = 1; i <= totalPDFPages; i++) {
        pdf.addPage(PDF_Width, PDF_Height);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          -(PDF_Height * i) + top_left_margin * 4,
          canvas_image_width,
          canvas_image_height
        );
      }
      pdf.save(`${SECTION.RESUME_NAME}.pdf`);
      setSnackBarData({
        ...snackBarData,
        open: true,
        message: DOWNLOAD_SUCCESSFULL,
      });
      setIsLoading(false);
      handleAfterResumeDownload(type);
    });
  };

  const handleMenuItemEditModeClick = () => {
    if (isMobile()) {
      setSnackBarData({
        open: true,
        message: SWITCH_TO_DESKTOP("Edit Sections"),
      });
      setMenuState(null);
      return;
    }
    setEditMode(!editMode);
    setSnackBarData({
      open: true,
      message: !editMode
        ? SECTION.EDIT_MODE_ENABLED
        : SECTION.VIEW_MODE_ENABLED,
    });
    setMenuState(null);

    !editMode &&
      setTimeout(() => {
        setSnackBarData({
          open: true,
          message: SECTION.DRAG_SECTIONS,
        });
      }, 10000);
  };

  const [currentPopOverData, setPopOverData] = React.useState({
    currentTarget: null,
    content: "",
  });
  const handleClick = (evt, content, other) => {
    setPopOverData({
      currentTarget: evt.currentTarget,
      content: content,
      other: other,
    });
  };
  const handlePopOverClose = () => {
    setPopOverData({
      currentTarget: null,
      content: "",
    });
  };

  const getPopOverComponent = (content, currentPopOverData) => {
    switch (content) {
      case SECTION.ABOUT_ME:
        return (
          <AboutMeEdit
            setPopOverData={setPopOverData}
            setSnackBarData={setSnackBarData}
          />
        );
      case SECTION.WORK_EX:
        return (
          <WorkExEdit
            setPopOverData={setPopOverData}
            setSnackBarData={setSnackBarData}
          />
        );
      case SECTION.SKILLS_SECTION:
        return (
          <SkillsEdit
            isLanguage={currentPopOverData.other === "language" ? true : false}
            setPopOverData={setPopOverData}
            setSnackBarData={setSnackBarData}
          />
        );
      case SECTION.PROJECTS:
        return (
          <ProjectEdit
            useDataFromKey={currentPopOverData.other}
            setPopOverData={setPopOverData}
            setSnackBarData={setSnackBarData}
          />
        );
      case SECTION.EDUCATION:
        return (
          <EducationEdit
            setPopOverData={setPopOverData}
            setSnackBarData={setSnackBarData}
          />
        );
      case SECTION.OPEN_TEMPLATES_DIALOG:
        return (
          <ChooseTemplate
            setPopOverData={setPopOverData}
            setSnackBarData={setSnackBarData}
          />
        );
      case SECTION.CONFIRM_DIALOG:
        return (
          <ConfirmDialog
            onCancelClick={setMenuState}
            onSaveClick={
              currentPopOverData.onSaveClick || props.setDefaultState
            }
            setPopOverData={setPopOverData}
            setSnackBarData={setSnackBarData}
          />
        );
      default:
        return content;
    }
  };

  const getGridGuideLines = () => (
    <section className={s.gridGuideContainer}>
      <section className={s.verticalGridContainer}>
        {Array(80)
          .fill()
          .map((x, i) => (
            <div key={i} className={classes.gridLine}></div>
          ))}
      </section>
      <section className={s.horizontalGridContainer}>
        {Array(100)
          .fill()
          .map((x, i) => (
            <div key={i} className={classes.gridLine}></div>
          ))}
      </section>
    </section>
  );

  const getCheckBoxAdditionalSectionsList = (itemsObject = {}) => {
    let items = [];
    for (let [key, value] of Object.entries(itemsObject)) {
      items.push({ ...value, key });
    }
    return items;
  };

  const handleCheckGroupChange = (items) => {
    let additionalSections = {};
    items.forEach((x) => {
      additionalSections[x.key] = x;
    });
    props.updateAdditionalSections(additionalSections);
  };

  const [menuState, setMenuState] = useState(null);
  const [exportMenuState, setExportMenuState] = useState(null);
  const getAppBar = () => (
    <AppBar className={classes.secondaryTextColor}>
      <Toolbar className={cx(classes.primaryThemeColorBg, s.iconsContainer)}>
        <section className={s.leftIconsContainer}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={(evt) => setMenuState(evt.currentTarget)}
          >
            <MenuIcon />
          </IconButton>
          <section>
            <Typography className={classes.siteHeading}>Fast Resume</Typography>
          </section>
        </section>

        <Menu
          id="menu-comp"
          open={Boolean(menuState)}
          anchorEl={menuState}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          onClose={() => setMenuState(null)}
        >
          <section
            className={cx(s.menuItemsContainer, classes.primaryThemeColor)}
          >
            <MenuItem onClick={handleMenuItemEditModeClick}>
              <div className={s.defaultResumeOption}>
                {editMode
                  ? MENU_ITEMS.VIEW_MODE.VALUE
                  : MENU_ITEMS.EDIT_MODE.VALUE}
                {editMode ? (
                  <span className={classes.secondaryTextColor}>
                    {MENU_ITEMS.VIEW_MODE.SUB_TEXT}
                  </span>
                ) : (
                  <span className={classes.secondaryTextColor}>
                    {MENU_ITEMS.EDIT_MODE.SUB_TEXT}
                  </span>
                )}
              </div>
            </MenuItem>
            <MenuItem
              onClick={(evt) => {
                handleClick(evt, SECTION.OPEN_TEMPLATES_DIALOG);
                setMenuState(null);
              }}
            >
              <div className={s.defaultResumeOption}>
                {MENU_ITEMS.CHOOSE_TEMPLATE.VALUE}
                <span className={classes.secondaryTextColor}>
                  {MENU_ITEMS.CHOOSE_TEMPLATE.SUB_TEXT}
                </span>
              </div>
            </MenuItem>
            <MenuItem
              onClick={(evt) => {
                toggleDrawer(true)(evt);
                setMenuState(null);
              }}
            >
              <div className={s.defaultResumeOption}>
                {MENU_ITEMS.HELP.VALUE}
                <span className={classes.secondaryTextColor}>
                  {MENU_ITEMS.HELP.SUB_TEXT}
                </span>
              </div>
            </MenuItem>
          </section>
          <MenuItem
            onClick={(evt) => {
              setMenuState(null);
              setPopOverData({
                currentTarget: evt.currentTarget,
                content: SECTION.CONFIRM_DIALOG,
              });
            }}
          >
            <div className={s.defaultResumeOption}>
              {MENU_ITEMS.DEFAULT_RESUME.VALUE}
              <span className={classes.secondaryTextColor}>
                {MENU_ITEMS.DEFAULT_RESUME.SUB_TEXT}
              </span>
            </div>
          </MenuItem>
          <MenuItem
            onClick={() =>
              window.open("https://twitter.com/abhikum144", "_blank")
            }
          >
            <div className={s.defaultResumeOption}>
              {MENU_ITEMS.FOLLOW_CREATOR.VALUE}
              <span className={classes.secondaryTextColor}>
                {MENU_ITEMS.FOLLOW_CREATOR.SUB_TEXT}
              </span>
            </div>
          </MenuItem>
        </Menu>
        <section className={s.rightIconContainer}>
          <BackDropLoader open={isLoading || props.isLoading} />
          <IconButton
            edge="end"
            aria-label="change theme color"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
          >
            <Tooltip title="Change Theme Color" aria-label="Change Theme Color">
              <input
                className={s.inputTypeColor}
                type="color"
                onChange={(evt) => {
                  props.handlePrimaryColorChange(evt.currentTarget.value);
                }}
              />
            </Tooltip>
          </IconButton>
          <IconButton
            edge="end"
            aria-label="Export/Import Resume"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={(evt) => setExportMenuState(evt.currentTarget)}
            color="inherit"
          >
            <Tooltip
              title="Export/Import Resume"
              aria-label="Export/Import Resume"
            >
              <ImportExportIcon />
            </Tooltip>
          </IconButton>
          <Menu
            id="menu-comp"
            open={Boolean(exportMenuState)}
            anchorEl={exportMenuState}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            onClose={() => setExportMenuState(null)}
          >
            <MenuItem
              onClick={(evt) => {
                downloadResume(DOWNLOAD_TYPES.PDF);
                setExportMenuState(null);
              }}
            >
              <div className={s.defaultResumeOption}>
                {MENU_ITEMS.EXPORT_AS_PDF.VALUE}
                <span className={classes.secondaryTextColor}>
                  {MENU_ITEMS.EXPORT_AS_PDF.SUB_TEXT}
                </span>
              </div>
            </MenuItem>
            <MenuItem
              onClick={(evt) => {
                downloadResume(DOWNLOAD_TYPES.JPEG);
                setExportMenuState(null);
              }}
            >
              <div className={s.defaultResumeOption}>
                {MENU_ITEMS.EXPORT_AS_JPEG.VALUE}
                <span className={classes.secondaryTextColor}>
                  {MENU_ITEMS.EXPORT_AS_JPEG.SUB_TEXT}
                </span>
              </div>
            </MenuItem>
            <MenuItem
              onClick={(evt) => {
                downloadResume(DOWNLOAD_TYPES.FILE);
                setExportMenuState(null);
              }}
            >
              <div className={s.defaultResumeOption}>
                {MENU_ITEMS.EXPORT_AS_FILE.VALUE}
                <span className={classes.secondaryTextColor}>
                  {MENU_ITEMS.EXPORT_AS_FILE.SUB_TEXT}
                </span>
              </div>
            </MenuItem>
            <MenuItem onClick={(evt) => {}}>
              <input
                style={{
                  display: "none",
                }}
                accept="application/JSON"
                className={classes.input}
                id="contained-button-file"
                type="file"
                onChange={(evt) => {
                  const file = evt.target.files[0];
                  if (file) {
                    const reader = new FileReader();
                    reader.readAsText(file, "UTF-8");
                    reader.onload = function (evt) {
                      try {
                        const parsedData = JSON.parse(evt.target.result);
                        const keyArray = [
                          "additionalSections",
                          "initialData",
                          "isLoading",
                          "templateSelected",
                          "useGA",
                          "viewType",
                        ];
                        if (
                          keyArray.every((x) =>
                            Object.hasOwnProperty.call(parsedData, x)
                          )
                        ) {
                          setPopOverData({
                            currentTarget: evt.currentTarget,
                            content: SECTION.CONFIRM_DIALOG,
                            onSaveClick: () => {
                              props.setImportedDataFromFile(evt.target.result);
                              setSnackBarData({
                                open: true,
                                message: SECTION.FILE_IMPORT_MESSAGE,
                              });
                            },
                          });
                        } else {
                          throw new Error();
                        }
                      } catch (err) {
                        setSnackBarData({
                          open: true,
                          message: SECTION.FILE_CORRECT_EXTENSION_MESSAGE,
                        });
                      }
                    };
                    reader.onerror = function (evt) {
                      setSnackBarData({
                        open: true,
                        message: SECTION.FILE_IMPORT_ERROR_MESSAGE,
                      });
                    };
                  }
                  setExportMenuState(null);
                }}
              />
              <label
                style={{
                  cursor: "inherit",
                  width: "100%",
                }}
                htmlFor="contained-button-file"
              >
                <div className={s.defaultResumeOption}>
                  {MENU_ITEMS.IMPORT_FROM_FILE.VALUE}
                  <span className={classes.secondaryTextColor}>
                    {MENU_ITEMS.IMPORT_FROM_FILE.SUB_TEXT}
                  </span>
                </div>
              </label>
            </MenuItem>
          </Menu>

          <IconButton
            edge="end"
            aria-label="toggle-dark-theme"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={props.handleThemeToggle}
            color="inherit"
          >
            <Tooltip
              title="Toggle Dark/Light Theme"
              aria-label="Toggle Dark/Light Theme"
            >
              <Brightness4Icon />
            </Tooltip>
          </IconButton>
          {!editMode ? (
            <IconButton
              edge="end"
              aria-label="Switch To Edit Mode"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenuItemEditModeClick}
              color="inherit"
            >
              <Tooltip
                title="Switch To Edit Mode"
                aria-label="Switch To Edit Mode"
              >
                <EditIcon />
              </Tooltip>
            </IconButton>
          ) : (
            <IconButton
              edge="end"
              aria-label="Switch To View Mode"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenuItemEditModeClick}
              color="inherit"
            >
              <Tooltip
                title="Switch To View Mode"
                aria-label="Switch To View Mode"
              >
                <CheckCircleOutlineIcon />
              </Tooltip>
            </IconButton>
          )}
        </section>
      </Toolbar>
    </AppBar>
  );

  const getBackGround = (backgroundType) => {
    switch (backgroundType) {
      case "none":
        return {
          background: "none",
        };
      case "rightGradient":
        return {
          background: `linear-gradient(to right, rgba(${hexToRgbA(
            props.themeColor
          )}, 0.7), ${
            props.themeType === "light"
              ? "rgba(255,255,255,1)"
              : "rgba(66,66,66,1)"
          })`,
        };
      case "leftGradient":
        return {
          background: `linear-gradient(to left, rgba(${hexToRgbA(
            props.themeColor
          )}, 0.7), ${
            props.themeType === "light"
              ? "rgba(255,255,255,1)"
              : "rgba(66,66,66,1)"
          })`,
        };
      case "topGradient":
        return {
          background: `linear-gradient(to top, rgba(${hexToRgbA(
            props.themeColor
          )}, 0.7), ${
            props.themeType === "light"
              ? "rgba(255,255,255,1)"
              : "rgba(66,66,66,1)"
          })`,
        };
      case "bottomGradient":
        return {
          background: `linear-gradient(to bottom, rgba(${hexToRgbA(
            props.themeColor
          )}, 0.7), ${
            props.themeType === "light"
              ? "rgba(255,255,255,1)"
              : "rgba(66,66,66,1)"
          })`,
        };
      case "light":
        return {
          background: "rgba(255,255,255,1)",
        };
      case "dark":
        return {
          background: "rgba(66,66,66,1)",
        };
      default:
        return {
          background: "none",
        };
    }
  };

  const getTemplate = (template) => {
    switch (template) {
      case "default":
        return (
          <DefaultTemplate
            editMode={editMode}
            constraintsRef={constraintsRef}
            handleClick={handleClick}
            {...props}
          />
        );
      case "classic":
        return (
          <SidePanelTemplate
            editMode={editMode}
            constraintsRef={constraintsRef}
            handleClick={handleClick}
            {...props}
          />
        );
      case "simple":
        return (
          <SimpleTemplate
            editMode={editMode}
            constraintsRef={constraintsRef}
            handleClick={handleClick}
            {...props}
          />
        );
      case "modern":
        return (
          <ModernTemplate
            editMode={editMode}
            constraintsRef={constraintsRef}
            handleClick={handleClick}
            {...props}
          />
        );
      case "colour":
        return (
          <SideDetailsTemplate
            editMode={editMode}
            constraintsRef={constraintsRef}
            handleClick={handleClick}
            {...props}
          />
        );
      case "design":
        return (
          <DesignTemplate
            editMode={editMode}
            constraintsRef={constraintsRef}
            handleClick={handleClick}
            {...props}
          />
        );
      default:
        return (
          <DefaultTemplate
            editMode={editMode}
            constraintsRef={constraintsRef}
            handleClick={handleClick}
            {...props}
          />
        );
    }
  };
  const constraintsRef = useRef(null);

  const [drawerState, setDrawerState] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerState(open);
  };

  return (
    <section className={s.container}>
      <SimplePopover
        currentTarget={currentPopOverData.currentTarget}
        data={currentPopOverData}
        handlePopOverClose={handlePopOverClose}
        useFullWidth={
          ![SECTION.SKILLS_SECTION, SECTION.CONFIRM_DIALOG].includes(
            currentPopOverData.content
          )
        }
      >
        {getPopOverComponent(currentPopOverData.content, currentPopOverData)}
      </SimplePopover>
      <CssBaseline />
      <SnackBar data={snackBarData} handleClose={handleSnackBarClose} />

      <Drawer
        className={s.drawerSection}
        anchor={"right"}
        open={drawerState}
        onClose={toggleDrawer(false)}
      >
        <ExploreFeatures />
      </Drawer>
      {getAppBar()}
      <Toolbar id="back-to-top-anchor" />
      {!props.isLoading && (
        <Container>
          <section
            id="root-container"
            style={getBackGround(props.viewType.backgroundType)}
            className={s.templateLayoutContainer}
          >
            {editMode && (
              <div className={s.checkBoxContainer}>
                <CheckBoxGroup
                  list={getCheckBoxAdditionalSectionsList(
                    props.additionalSections
                  )}
                  handleCheckGroupChange={handleCheckGroupChange}
                />
              </div>
            )}
            {getTemplate(props.templateSelected)}
            {editMode && getGridGuideLines()}
            <div className={cx(s.footerMessage, classes.secondaryTextColor)}>
              <span>{SECTION.WEBSITE_FOOTER_MSG}</span>
            </div>
          </section>
        </Container>
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  ...state.mainLayoutReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getLayoutDetail: () => {
      getLayoutDetail()(dispatch);
    },
    setDefaultState: () => {
      setDefaultState()(dispatch);
    },
    updateAdditionalSections: (additionalSections) => {
      updateAdditionalSections(additionalSections)(dispatch);
    },
    setImportedDataFromFile: (importFileData) => {
      setImportedDataFromFile(importFileData)(dispatch);
    },
    dispatch,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainLayout)
);

const compClasses = (theme) => ({
  siteHeading: {
    textTransform: "uppercase",
    fontWeight: "700",
    fontSize: "1rem",
  },
  gridLine: {
    border: `0.5px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.04)"
        : "rgba(0,0,0,0.04)"
    }`,
  },
});
